module.exports = __webpack_public_path__ + "media/src/img/how-1-648d773c806d6e7b6917cc80e93733a3.jpg";